export default {"src":"/newStatic/_next/static/media/pattern-5.091089ec.svg","height":40,"width":768};